import { makeGetCsv } from '../make-api'

const REPORT_BENOIT = '/ReportBenoit'

const reportBenoitApi = {
  getReportBenoit: makeGetCsv(REPORT_BENOIT),
}

export default reportBenoitApi
